export default __webpack_public_path__ + "static/media/ferry.d67c5abf.svg";